import Node from './Node';
import { SignalBusConfig } from './SignalBus';
import buildWSURL from './buildWSURL';
import prependProtocol from '../../common/utils/prependProtocol';

export default class PeerConfig {
  readonly node: Node;
  readonly peerLimit: number;
  readonly eventBusEndpoint: string;
  readonly eventBusServerAddress: string;
  readonly eventBusLocalAddress: string;
  readonly rtcConfiguration: RTCConfiguration;
  readonly signalHost: string;
  readonly token: string;

  constructor(
    config: {
      node: Node;
      peerLimit: number;
      eventBusEndpoint: string;
      eventBusServerAddress: string;
      eventBusLocalAddress: string;
      rtcConfiguration: RTCConfiguration;
    },
    signalHost: string,
    token: string
  ) {
    this.node = Node.from(config.node);
    this.peerLimit = config.peerLimit || 15;
    this.eventBusEndpoint = config.eventBusEndpoint;
    this.eventBusServerAddress = config.eventBusServerAddress;
    this.eventBusLocalAddress = config.eventBusLocalAddress;
    this.rtcConfiguration = config.rtcConfiguration;
    this.signalHost = signalHost;
    this.token = token;
  }

  /**
   * Get configuration for the EventBus class
   * @returns object containing configurations for the EventBus
   */
  get signalingConfig(): SignalBusConfig {
    return {};
  }

  /**
   * Get endpoint for connectin to the EventBus
   * @returns url for the EventBus
   */
  get eventBusEndpointURL(): string {
    return buildWSURL(
      this.signalHost,
      this.eventBusEndpoint,
      this.node,
      this.token
    );
  }

  get coordinatorDetachUrl(): string {
    return new URL(
      '/api/rtc/coordinator/detach',
      prependProtocol(this.signalHost)
    ).toString();
  }
}
